import Upload from './Upload'

export default Upload



// WEBPACK FOOTER //
// ./src/components/upload/index.js